import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings';
import { slideToggle } from './../../composables/slideToggle';
import { useEffect, useState } from "react";
import { useMsal } from '@azure/msal-react';
import { useSignalR, useUserProfile } from '../../app';
import useTrackedProperty from '../../app/useTrackedProperty';

export const SidebarProfile = () => {

	const { accounts } = useMsal();
	const signalRApi = useSignalR();
	const profile = useUserProfile();
	const profileImage = useTrackedProperty(profile, "aadProfileImage");

	const [userProfileImages, setUserProfileImages] = useState({ default: "./../../../assets/img/user/user-12.jpg" });

	const handleUserUpdate = user => {
		if (!user || !user.id) return;
		setUserProfileImages(current => ({
			...current,
			[user.id]: user.thumbnailProfileImageIncludingSasToken
		}));
	};

	useEffect(() => {
		if (profileImage && profile && profile.systemProfile) {
			handleUserUpdate(profile.systemProfile);
		}
	}, [profile, profileImage]);

	useEffect(() => {
		if (!signalRApi) return;

		const handleHeartbeat = data => {
			handleUserUpdate(data.user);
		};

		signalRApi.subscribe("heartbeat", handleHeartbeat);

		return () => {
			signalRApi.unsubscribe("heartbeat", handleHeartbeat);
		};

	}, [signalRApi]);

	const handleProfileExpand = (e) => {
		e.preventDefault();

		var targetSidebar = document.querySelector('.app-sidebar:not(.app-sidebar-end)');
		var targetMenu = e.target.closest('.menu-profile');
		var targetProfile = document.querySelector('#appSidebarProfileMenu');
		var expandTime = (targetSidebar && targetSidebar.getAttribute('data-disable-slide-animation')) ? 0 : 250;

		if (targetProfile) {
			if (targetProfile.style.display === 'block') {
				targetMenu.classList.remove('active');
			} else {
				targetMenu.classList.add('active');
			}
			slideToggle(targetProfile, expandTime);
			targetProfile.classList.toggle('expand');
		}
	}

	const profileImageKey = profile?.systemProfile?.id;
	const profileImageValue = profileImageKey ? userProfileImages[profileImageKey] : null;
	const isPlaceholderAvatar = !profileImageValue;
	const usingFallbackAvatar = isPlaceholderAvatar;
	const shouldAnimateAvatar = usingFallbackAvatar;
	const getMyUserProfileImage = () => usingFallbackAvatar ? userProfileImages.default : profileImageValue;
	const profileName = profile?.systemProfile?.givenName
		?? profile?.graphMe?.givenName
		?? accounts?.[0]?.name
		?? accounts?.[0]?.username
		?? "User";
	const profileTitle = profile?.systemProfile?.jobTitle
		?? profile?.graphMe?.jobTitle
		?? "Loading profile...";
	
	return accounts?.[0] ? (
		<AppSettings.Consumer>
			{({ appSidebarMinify }) => (
				<div className="menu">
					<div className="menu-profile">
						<Link to="/" onClick={handleProfileExpand} className="menu-profile-link">
							<div className="menu-profile-cover with-shadow"></div>
							<div className="menu-profile-image">
								<img className={shouldAnimateAvatar ? "pm-avatar-loading" : ""} src={getMyUserProfileImage()} alt="" />
							</div>
							<div className="menu-profile-info">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										{profileName}
									</div>
									<div className="menu-caret ms-auto"></div>
								</div>
								<small>{profileTitle}</small>
							</div>
						</Link>
					</div>
					<div id="appSidebarProfileMenu" className="collapse">
						<div className="menu-item pt-5px">
							<Link to="/user/me" className="menu-link">
								<div className="menu-icon"><i className="fa fa-cog"></i></div>
								<div className="menu-text">Settings</div>
							</Link>
						</div>
						<div className="menu-item">
							<Link to="/" className="menu-link">
								<div className="menu-icon"><i className="fa fa-pencil-alt"></i></div>
								<div className="menu-text"> Send Feedback</div>
							</Link>
						</div>
						<div className="menu-item pb-5px">
							<Link to="/" className="menu-link">
								<div className="menu-icon"><i className="fa fa-question-circle"></i></div>
								<div className="menu-text"> Help</div>
							</Link>
						</div>
						<div className="menu-divider m-0"></div>
					</div>
				</div>
			)}
		</AppSettings.Consumer>
	) :
		(
			<>Loading...</>
		)
		;
}